var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"dialog":_vm.s_dialogColor,"id":"dialog-color"}},[_c('div',{style:(_vm.contentSize)},[_c('chrome-picker',{model:{value:(_vm.s_featureColor),callback:function ($$v) {_vm.s_featureColor=$$v},expression:"s_featureColor"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }